module.exports = __webpack_public_path__ + "img/enfermeria-foto1.1932935f.png";